<template>
  <div>
    <account-information
      v-if="isBtoC && display === 'user-data-input'"
      :company-id="getCompanyId()"
      @showSection="show('confirm-user-data')" />
    <confirm-account-information
      v-else-if="isBtoC && display === 'confirm-user-data'"
      :company-id="getCompanyId()"
      @onCompleteRelease="completeRelease()"
      @show="show" />
    <mobile-registration
      v-if="isBtoC && display === 'mobile-input'"
      :is-first-time="isFirstTime"
      :saved-mobile="mobileNumber"
      :parent-message="errorMessageToParent"
      @onMobileReturnClicked="onMobileReturnClicked"
      @smsResponse="smsResponse($event)" />
    <security-code-registration
      v-if="isBtoC && display === 'security-code-input'"
      :mobile-number="mobileNumber"
      :has-settled="hasSettled"
      :is-subscriber="isSubscriber"
      :is-mate="isMate"
      :is-payment="isPayment"
      @setErrorMessage="setErrorMessage"
      @emitIsFirstTime="handleFirstTime"
      @displayMobileRegistration="displayMobileRegistration()"
      @securityCodeResponse="securityCodeResponse($event)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountInformation from '../../User/AccountInformation'
import ConfirmAccountInformation from '../../User/ConfirmAccountInformation'
import MobileRegistration from '../../Mfa/PhoneRegistration'
import SecurityCodeRegistration from '../../Mfa/SecurityCodeRegistration'

export default {
  name: 'ReleaseUserInfoConfirmAndSmsAuth',
  components: {
    AccountInformation,
    ConfirmAccountInformation,
    MobileRegistration,
    SecurityCodeRegistration,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    mobile: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      display: '',
      mobileNumber: this.mobile,
      isFirstTime: true,
      errorMessageToParent: '',
      hasSettled: 0,
      productId: 0,
      isPayment: true,
    }
  },
  computed: {
    ...mapGetters('auth', ['isSubscriber', 'isMate']),
  },
  watch: {
    content(section) {
      this.display = section
    },
  },
  mounted() {
    this.display = this.content
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.hasSettled = release.has_settled ?? 0
    this.productId = release.product.id ?? 0
    this.isLimitMonthlyRrelease()
  },
  methods: {
    getCompanyId() {
      return JSON.parse(window.sessionStorage.getItem('account_information')).id
    },
    show(section = '') {
      this.scrollToTop()
      this.display = section
    },
    // handle operation after registering mobile number
    smsResponse({ mobileNumber }) {
      this.scrollToTop()
      this.display = 'security-code-input'
      this.mobileNumber = mobileNumber
    },
    /* change text of mobile registration form when redisplayed again
    after clicking back button or user sms lock  */
    handleFirstTime({ firstTime }) {
      this.isFirstTime = firstTime
    },
    // handle remaining operations after successful sms security code verification
    securityCodeResponse(event) {
      if (event.response.data.error === false) {
        this.$emit('on-release-clicked')
      }
    },
    // handle back button clicked and user sms locked after 3 wrong input.
    displayMobileRegistration() {
      this.scrollToTop()
      this.display = 'mobile-input'
      this.isFirstTime = false
    },
    // set error message to display in parent component
    setErrorMessage({ error }) {
      this.errorMessageToParent = error
    },
    // on return clicked from mobile registration screen
    onMobileReturnClicked() {
      this.scrollToTop()
      this.display = 'confirm-user-data'
    },
    // display complete screen, if it is re-applied from store addition
    completeRelease() {
      this.$emit('on-release-clicked')
    },
    async isLimitMonthlyRrelease() {
      const response = await window.axios.get(`/api/client/products/${this.productId}/monthly-release-limit`)
      const isWithinLimitMonthlyRreleases = response.data.result
      if (this.isBtoB
            || (this.isSubscriber && isWithinLimitMonthlyRreleases)
            || this.hasSettled === 1
            || this.isMate) {
        this.isPayment = false
      } else {
        this.isPayment = true
      }
    },
  },
}
</script>
